import React, { useState, useEffect } from "react";
import Table from "../../../../app/components/Table";
import { AnimatePresence, motion } from "framer-motion";
import CheckBox from "../../../../app/components/CheckBox";
import Button from "../../../../app/components/Button";
import {
  FiAlertTriangle,
  FiPaperclip,
  FiAlertOctagon,
  FiPlus,
  FiEdit,
  FiTrash,
} from "react-icons/fi";
import TakeFilesEdit from "../../../../forms/takeFiles/TakeFileEdit";
import DropdownActions from '../../../../app/components/DropdownActions';
import Toast from "../../../../app/components/Toast";
import FormServiceDelete from "../../../../forms/FormsListOfOrders/FormServiceDelete";
import SummaryCard from "../../../../app/components/SummaryCard";
import { usePageTitle } from '../../../../contexts/PageTitleContext';

const TakeFiles = () => {
  const { setTitle } = usePageTitle();
      
  useEffect(() => {
    setTitle('Leva Arquivos');
  }, [setTitle]);

  const [selectedIds, setSelectedIds] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [deleteMultipleOpen, setDeleteMultipleOpen] = useState(false);

  const [toast, setToast] = useState({ show: false, type: "success", message: "" });

  const [searchTerm, setSearchTerm] = useState("");
  const [paginaAtual, setPaginaAtual] = useState(1);
  const itensPorPagina = 10;

  
  const [dataServices, setDataServices] = useState([
    {
      id: 1,
      nome: "Relação de empregados",
      obrigacao: "Folha de Pagamento",
      passivel_multa: "Não",
    },
    { id: 2, nome: "RE FGTS", obrigacao: "Folha de pagamento", passivel_multa: "Sim" },
  ]);

  const openEditModal = (item) => {
    setSelectedItem(item);
    setEditModalOpen(true);
  };
  
  const handleSave = (itemData) => {
    if (selectedItem) {
      setDataServices((prev) =>
        prev.map((item) => (item.id === selectedItem.id ? { ...item, ...itemData } : item))
    );
    setToast({ show: true, type: "success", message: "Arquivo atualizado com sucesso!" });
  } else {
    const newId = dataServices.length > 0 ? Math.max(...dataServices.map((d) => d.id)) + 1 : 1;
      setDataServices((prev) => [...prev, { id: newId, ...itemData }]);
      setToast({ show: true, type: "success", message: "Novo arquivo adicionado!" });
    }
    setEditModalOpen(false);
  };
  
  const handleDelete = (item) => {
    setSelectedItem(item);
    setDeleteModalOpen(true);
  };
  
  const handleConfirmDelete = () => {
    try {
      if (selectedItem?.id) {
        setDataServices((prev) => prev.filter((item) => item.id !== selectedItem.id));
        setToast({ show: true, type: "success", message: "Arquivo excluído com sucesso!" });
      }
    } catch (err) {
      setToast({ show: true, type: "error", message: err.message || "Erro ao excluir arquivo." });
    } finally {
      setDeleteModalOpen(false);
    }
  };
  
  const dadosFiltrados = dataServices.filter((item) =>
    item.nome.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const dadosPaginados = dadosFiltrados.slice(
    (paginaAtual - 1) * itensPorPagina,
    paginaAtual * itensPorPagina
  );

  const dadosComAcoes = dadosPaginados.map((item) => ({
    ...item,
    acoes: (
      <div className="flex justify-center">
        <DropdownActions
          actions={[
            {
              label: 'Editar',
              icon: FiEdit,
              onClick: () => openEditModal(item),
            },
            {
              label: 'Excluir',
              icon: FiTrash,
              onClick: () => handleDelete(item),
            },
          ]}
          />
      </div>
    ),
  }));



  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedIds([]);
    } else {
      setSelectedIds(dataServices.map((item) => item.id));
    }
    setAllSelected(!allSelected);
  };

  const handleRowSelect = (id) => {
      if (selectedIds.includes(id)) {
        setSelectedIds(selectedIds.filter((itemId) => itemId !== id));
      } else {
        setSelectedIds([...selectedIds, id]);
      }
  };
  
  const columns = [
    {
      campo: "checkbox",
      titulo: <CheckBox checked={allSelected} onChange={handleSelectAll} />,
      tipo: "custom",
      render: (item) => (
        <CheckBox
        checked={selectedIds.includes(item.id)}
        onChange={() => handleRowSelect(item.id)}
        />
      ),
    },
    { campo: "id", titulo: "Id" },
    { campo: "nome", titulo: "Nome" },
    { campo: "obrigacao", titulo: "Obrigação" },
    { campo: "passivel_multa", titulo: "Passível De Multa" },
    { campo: "acoes", titulo: "Ações", tipo: "acoes", centralizado: true },
  ];
  
  const handleClickAdd = () => {
    setEditModalOpen(true);
    setSelectedItem(null);
  };
  
  const handleModalClose = () => {
    setEditModalOpen(false);
  };
  
  return (
    <div>
      <div>
        <div className="flex items-center gap-2 mb-4">
           <motion.div
              layout
              initial={false}
              animate={{ width: selectedIds.length > 0 ? 180 : 40 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="overflow-hidden rounded-2xl bg-primary text-white h-[40px] flex items-center"
            >
            <AnimatePresence mode="wait">
              {selectedIds.length > 0 ? (
                <motion.button
                  key="delete"
                  initial={{ opacity: 1, x: 10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3 }}
                  onClick={() => setDeleteMultipleOpen(true)}
                  className="flex items-center justify-center h-full text-sm whitespace-nowrap w-full"
                >
                  <Button variant="primary">
                    <span className="p-4 text-xs">Apagar Selecionados</span>
                  </Button>
                </motion.button>
              ) : (
                <motion.button
                  key="add"
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.2 }}
                  onClick={handleClickAdd}
                  className="w-full h-full rounded-2xl flex items-center bg-[#3f1057] transition-colors duration-3000 hover:bg-[#5a167a] justify-center"
                >
                  <Button variant="primary">
                    <FiPlus size={16} />
                  </Button>
                </motion.button>
              )}
            </AnimatePresence>
          </motion.div>
          
          <label
            htmlFor="fileInput"
            className="grid border-[#3f1057]/60 border-2 border-dashed cursor-pointer w-full bg-gray-50 hover:bg-[#3f1057]/10 text-center py-2 rounded-2xl transition-colors duration-300 ease-in-out"
            >
            <p className="font-semibold text-[#3f1057] text-sm">Adicionar novo arquivo</p>
            <input type="file" id="fileInput" style={{ display: "none" }} />
          </label>
        </div>

        <Table
          colunas={columns}
          dados={dadosComAcoes}
          renderizarConteudo={(coluna, item) => {
            if (coluna.render) return coluna.render(item);
            return item[coluna.campo];
          }}
        />
      </div>

      <div className="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-2 gap-4 mt-16">
        <SummaryCard 
          icon={FiPaperclip} 
          title="Tarefas Encontradas" 
          value="1" 
        />
        <SummaryCard
          icon={FiAlertTriangle}
          title="Tarefas Não Encontradas"
          value="1"
          color="#FBBF24"
        />
        <SummaryCard
          icon={FiAlertOctagon}
          title="Tarefas com Erro"
          value="1"
          color="#EF4444"
        />
      </div>

      <TakeFilesEdit
        isOpen={editModalOpen}
        onClose={handleModalClose}
        onSubmit={handleSave}
        title={selectedItem ? "Editar Arquivo" : "Novo Arquivo"}
        initialData={selectedItem}
      />

      <FormServiceDelete
        isOpen={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
        order={selectedItem}
      />

      <FormServiceDelete
        isOpen={deleteMultipleOpen}
        onClose={() => setDeleteMultipleOpen(false)}
        onConfirm={() => {
          setDataServices((prev) =>
            prev.filter((item) => !selectedIds.includes(item.id))
          );
          setSelectedIds([]);
          setAllSelected(false);
          setToast({
            show: true,
            type: "success",
            message: "Itens selecionados apagados com sucesso!",
          });
          setDeleteMultipleOpen(false);
        }}
        order={{ nome: `${selectedIds.length} itens selecionados` }}
      />

      {toast.show && (
        <Toast
          type={toast.type}
          message={toast.message}
          duration={3000}
          onClose={() => setToast((prev) => ({ ...prev, show: false }))}
        />
      )}
    </div>
  );
};

export default TakeFiles;